/* eslint-disable @typescript-eslint/naming-convention */
export const REQUIRED_VALIDATION = (label: string) => {
  return `${label} is required!`;
};

/* eslint-disable @typescript-eslint/naming-convention */
export const LENGTH_VALIDATION = (label: string) => {
  return `${label} is required!`;
};
